import React from "react";

import "./Jobs.scss";

const Jobs = () => {
	return (
		<a
			className="discovery-promo-jobs"
			href="/careers"
			target="_blank"
			rel="noopener noreferrer"
		>
			<h3 className="discovery-promo-jobs-title">
				Work at OkCupid
			</h3>
			<p className="discovery-promo-jobs-content">
				If you’re smart and love to help people, join our team.
			</p>
			<span className="discovery-promo-jobs-link">
				View careers
			</span>
		</a>
	);
};

export default Jobs;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/interruptions/Jobs.jsx